import React, { useEffect, useState, useMemo } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import { db, functions } from "../../../firebase";
import { TENANT_ID } from "../../../tenant";
import { Users } from "lucide-react";

const FacilityStatusCard = () => {
  const [doorStats, setDoorStats] = useState({});
  const [capacityLevels, setCapacityLevels] = useState([]);

  // =========================
  // capacity_levels 取得
  // =========================
    useEffect(() => {
    const ref = doc(db, "tenants", TENANT_ID, "config", "app");

    const unsub = onSnapshot(ref, (snap) => {
        if (!snap.exists()) return;
        const levels = snap.data()?.capacity_levels || [];
        setCapacityLevels(levels);
    });

    return () => unsub();
    }, []);

  // =========================
  // ドア別の在室人数（active_sessions は rules で管理者専用。人数だけ返す callable を1分ごとに）
  // =========================
    useEffect(() => {
    let alive = true;
    const load = async () => {
        try {
        const res = await httpsCallable(functions, "getFacilityCongestion")({ tenantId: TENANT_ID });
        if (!alive) return;
        const next = {};
        (res.data?.doors || []).forEach((d) => {
            next[d.doorId] = { name: d.name, capacity: Number(d.capacity || 0), current: Number(d.current || 0) };
        });
        setDoorStats(next);
        } catch (e) {
        console.warn("[FacilityStatusCard] getFacilityCongestion failed:", e?.code, e?.message || e);
        }
    };
    load();
    const t = setInterval(load, 60 * 1000);
    return () => {
        alive = false;
        clearInterval(t);
    };
    }, []);
  // =========================
  // レベル判定
  // =========================
  const resolveLevel = (percent) => {
    if (!Array.isArray(capacityLevels)) return null;

    return (
      capacityLevels.find(
        (l) =>
          percent >= Number(l.min) &&
          percent <= Number(l.max)
      ) || null
    );
  };

  // =========================
  // level2以上抽出
  // =========================
  const congestedDoors = useMemo(() => {
    return Object.values(doorStats)
      .map((door) => {
        const percent =
          door.capacity > 0
            ? Math.round((door.current / door.capacity) * 100)
            : 0;

        const level = resolveLevel(percent);
        if (!level) return null;

        // level1を除外（min=0をlevel1と想定）
        if (Number(level.min) === 0) return null;

        return {
          name: door.name,
          label: level.label,
        };
      })
      .filter(Boolean);
  }, [doorStats, capacityLevels]);

  // =========================
  // UI
  // =========================
        return (
        <div className="bg-white rounded-3xl p-3 border border-gray-100 shadow-lg shadow-black/5 font-sans">

            <div className="flex items-start gap-1 pl-1.5 pr-2 mt-2">

            <div className="w-6 h-6 flex items-center justify-center mt-[-5px]">
                <Users size={15} />
            </div>

            <div className="text-[10px] text-gray-500 font-black uppercase tracking-[0.1em]">

            {congestedDoors.length === 0 ? (
            <div>いまの様子　ゆったりしています</div>
            ) : (
            <div className="grid grid-cols-[auto_1fr] gap-x-2">

                {/* 1行目 */}
                <div>いまの様子</div>
                <div>
                {congestedDoors[0].name} {congestedDoors[0].label}
                </div>

                {/* 2行目以降 */}
                {congestedDoors.slice(1).map((d) => (
                <React.Fragment key={d.name}>
                    <div></div>
                    <div>
                    {d.name} {d.label}
                    </div>
                </React.Fragment>
                ))}

            </div>
            )}

        </div>
        </div>
    </div>
    );
};

export default FacilityStatusCard;